import ShapesService from '@/services/ShapesService';
import PainterService from '@/services/PainterService';
import paper from 'paper';

const compoSyncPlugin = store => {

    let currentRequests = 0;
    // called when the store is initialized
    store.subscribe(async mutation => {
        // called after every mutation.
        // The mutation comes in the format of `{ type, payload }`.
        let composition;
        switch(mutation.type) {
            case 'compositions/unsetPending':
                if (currentRequests > 0) currentRequests--;
                break;
            case 'compositions/setPending':
                currentRequests++;
                if (currentRequests > 1) console.error('Requetes de composition concurrentes');
                break;
            case 'compositions/updateItem':
                if (currentRequests > 0) break;
                console.debug('Recieved external modification');

                paper.project.layers.selectable.removeChildren();
                composition = mutation.payload;
                composition.shapes.forEach(shape => {
                    ShapesService.importShape(shape);
                });
                store.commit('SET_CUTTING_OPTIONS', composition.cuttingOptions);
                store.commit('UPDATE_SHAPES', composition.shapes);
                await PainterService.repaint(composition);
                break;
        }
    })
}

export default compoSyncPlugin;
